import React from 'react';
import CommonModal from 'jbc-front/components/CommonModal';
import Button from 'jbc-front/components/Button';
import { reduxForm, getFormValues, SubmissionError } from 'redux-form';
import { TextField } from 'jbc-front/components/Form';
import { isEmail } from 'src/utils/CustomValidators';
import * as Urls from 'src/constants/EndpointUrls';

import {
  takeEmployeesSearchQueries,
  takeEmployeesSearchQueriesFromLocation,
  FORM_NAME_EMPLOYEES_SEARCH
} from 'src/reducers/searchForm';
import { fetchEmployees } from 'src/reducers/employees/employees';
import { connect } from 'react-redux';
import { concatParamsToUrl } from 'src/utils/Http';
import axios from 'axios';
import compose from 'lodash/fp/compose';
import isUseOtherApp from 'src/utils/JbcId';
import { EMPLOYEE_EMAIL_FORM } from 'src/constants/FormNames';
import { replaceMessages, employeeDisplay } from 'src/utils/Utils';
import { useTranslation } from 'react-i18next';

const EmailForm = compose(
  connect(state => ({
    searchValues: {
      ...takeEmployeesSearchQueriesFromLocation(state.router.location, true),
      ...getFormValues(FORM_NAME_EMPLOYEES_SEARCH)(state)
    }
  })),
  reduxForm({
    form: EMPLOYEE_EMAIL_FORM,
    enableReinitialize: true,
    onSubmit: async (values, dispatch, { hideModal, id, searchValues }) => {
      try {
        const editUrl = concatParamsToUrl(Urls.UPDATE_EMPLOYEE_EMAIL, { id });
        await axios.put(editUrl, { employee: values });
        dispatch(fetchEmployees(takeEmployeesSearchQueries(searchValues)));
        hideModal();
      } catch (exception) {
        const messages = replaceMessages(exception.response.data.errors.messages, ['メールアドレス'], ['']);
        throw new SubmissionError({ email: messages });
      }
    }
  })
)(({ handleSubmit, hideModal, submitting, name }) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <CommonModal.Header hideModal={hideModal}>{t('features.EmployeeInvitations.components.EmailForm.Email_address_registration')}</CommonModal.Header>
      <CommonModal.Body>
        <form onSubmit={handleSubmit}>
          <div className="form_box_main">
            <TextField
              name="email"
              label={t('features.EmployeeInvitations.components.EmailForm.s_email_address', { name })}
              validate={isEmail}
              maxLength="255"
            />
            {isUseOtherApp && (
              <p>{t('features.EmployeeInvitations.components.EmailForm.If_you_change_your_email_it_will_also_be_reflected_in_other_JOBCAN_services')}</p>
            )}
          </div>
        </form>
      </CommonModal.Body>
      <CommonModal.Footer>
        <CommonModal.Buttons>
          <Button onClick={hideModal}>{t('features.EmployeeInvitations.components.EmailForm.Cancel')}</Button>
          <Button primary onClick={handleSubmit} disabled={submitting}>
            {t('features.EmployeeInvitations.components.EmailForm.Save')}
          </Button>
        </CommonModal.Buttons>
      </CommonModal.Footer>
    </React.Fragment>
  );
});

const EmailModal = ({ hideModal, employee, isOpen }) => {
  const { i18n } = useTranslation();
  return (
    <CommonModal isOpen={isOpen} hideModal={hideModal}>
      {isOpen && <EmailForm initialValues={{ email: employee.email }} name={employeeDisplay.fullName(employee, i18n)} id={employee.id} hideModal={hideModal} />}
    </CommonModal>
  );
};

export default EmailModal;
